import "./instrument";
import { AuthUseCase } from 'application/usecases/AuthUseCase';
import { UserStorageUseCase } from 'application/usecases/UserStorageUseCase';
import { AuthAPI } from 'infrastructure/apis/AuthAPI';
import { PropertyAPI } from 'infrastructure/apis/PropertyAPI';
import { TestAPI } from 'infrastructure/apis/TestAPI';
import { UserStorage } from 'infrastructure/storages/UserStorage';
import { persistor, store } from 'presentation/redux/store';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import './index.scss';
import reportWebVitals from './reportWebVitals';

import { AssessmentUseCase } from 'application/usecases/AssessmentUseCase';
import { AuctionBidsUseCase } from 'application/usecases/AuctionBidsUseCase';
import { ChatUseCase } from 'application/usecases/ChatUseCase';
import { FileUseCase } from 'application/usecases/FileUseCase';
import { MasterUseCase } from 'application/usecases/MasterUseCase';
import { NotifyUseCase } from 'application/usecases/NotifyUseCase';
import { PropertyUseCase } from 'application/usecases/PropertyUseCase';
import { PurchaseUseCase } from 'application/usecases/PurchaseUseCase';
import { SimulateUseCase } from 'application/usecases/SimulateUseCase';
import { TestUseCase } from 'application/usecases/TestUseCase';
import { UserUseCase } from 'application/usecases/UserUseCase';
import { AssessmentAPI } from 'infrastructure/apis/AssessmentAPI';
import { AuctionBidsAPI } from 'infrastructure/apis/AuctionBidsAPI';
import { ChatAPI } from 'infrastructure/apis/ChatAPI';
import { FileAPI } from 'infrastructure/apis/FileAPI';
import { MasterAPI } from 'infrastructure/apis/MasterAPI';
import { NotifyAPI } from 'infrastructure/apis/NotifyAPI';
import { PurchaseAPI } from 'infrastructure/apis/PurchaseAPI';
import { SimulateAPI } from 'infrastructure/apis/SimulateAPI';
import { UserAPI } from 'infrastructure/apis/UserAPI';
import App from 'presentation/App';
import { HelmetProvider } from 'react-helmet-async';

const authRepository = new AuthAPI();
const notifyRepository = new NotifyAPI();
const userStorage = new UserStorage();
const testRepository = new TestAPI();
const propertyRepository = new PropertyAPI();
const masterRepository = new MasterAPI();
const assessmentRepository = new AssessmentAPI();
const auctionBidsRepository = new AuctionBidsAPI();
const simulateRepository = new SimulateAPI();
const purchaseRepository = new PurchaseAPI();
const fileRepository = new FileAPI();
const userRepository = new UserAPI();
const chatRepository = new ChatAPI();

const testUseCase = new TestUseCase(testRepository);
const userStorageUseCase = new UserStorageUseCase(userStorage);
const authUseCase = new AuthUseCase(authRepository);
const userUseCase = new UserUseCase(userRepository);
const propertyUseCase = new PropertyUseCase(propertyRepository);
const masterUseCase = new MasterUseCase(masterRepository);
const assessmentUseCase = new AssessmentUseCase(assessmentRepository);
const auctionBidsUseCase = new AuctionBidsUseCase(auctionBidsRepository);
const simulateUseCase = new SimulateUseCase(simulateRepository);
const purchaseUseCase = new PurchaseUseCase(purchaseRepository);
const fileUseCase = new FileUseCase(fileRepository);
const notifyUseCase = new NotifyUseCase(notifyRepository);
const chatUseCase = new ChatUseCase(chatRepository);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    // <React.StrictMode>
    <HelmetProvider>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <BrowserRouter>
                    <App
                        userStorageUseCase={userStorageUseCase}
                        testUseCase={testUseCase}
                        authUseCase={authUseCase}
                        userUseCase={userUseCase}
                        propertyUseCase={propertyUseCase}
                        masterUseCase={masterUseCase}
                        assessmentUseCase={assessmentUseCase}
                        auctionBidsUseCase={auctionBidsUseCase}
                        simulateUseCase={simulateUseCase}
                        purchaseUseCase={purchaseUseCase}
                        fileUseCase={fileUseCase}
                        notifyUseCase={notifyUseCase}
                        chatUseCase={chatUseCase}
                    />
                </BrowserRouter>
            </PersistGate>
        </Provider>
    </HelmetProvider>,
    // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
